export default {"src":"/_next/static/media/switch.b12ef3b0.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};